<template>
  <div class="shadow-xs rounded">
    <div class="shadow-lg rounded overflow-hidden bg-white flex flex-col">
      <div class="inline-flex px-4 h-12 items-center">
        <span class="inline-block truncate text-sm">
          {{ media.name }}
        </span>
      </div>
      <a
        :href="media.url"
        target="_blank"
        class="relative bg-gray-100"
        style="padding-bottom: 66.666667%"
      >
        <img v-if="media.url" :src="media.url" class="absolute w-full h-full object-cover" />
        <div v-else class="absolute w-full h-full inline-flex items-center justify-center">
          <div class="flex flex-col items-center space-y-4">
            <svg viewBox="0 0 24 24" fill="currentColor" class="h-12 w-12 text-gray-600">
              <path
                d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1
                1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793
                7.794-1.414-1.414L17.585 5H13V3h8z"
              />
            </svg>
            <p class="text-gray-900">No preview available</p>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    media: {
      type: Object,
      required: true,
    },
  },
};
</script>
